import { Action } from 'common/interfaces/root';
import { asinRecommendationActionTypes as TYPES } from '../actions/action-types';

const initialState: AsinRecommendationModule.State.PlacementsState = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: AsinRecommendationModule.State.PlacementsState = initialState,
  { type, payload }: Action
): AsinRecommendationModule.State.PlacementsState => {
  switch (type) {
    case TYPES.PLACEMENTS.GET_PLACEMENTS:
      return { ...state, loading: true };
    case TYPES.PLACEMENTS.GET_PLACEMENTS_SUCCESS:
      return { ...state, loading: false, data: payload };
    case TYPES.PLACEMENTS.GET_PLACEMENTS_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
